// extracted by mini-css-extract-plugin
export default {"likeButton":"VR-z","unLikedButton":"WR-z","likedButton":"XR-z"};